import React, { useEffect } from 'react';
import useGroupThree from './useGroupThree';
import { TEST_MODE } from '../../enums/enums';
import { useAppSelector } from '../../store';

export default function useGroupUpdate(
  chooseGroupId,
  setChooseGroupeId = () => {},
  isManualUpdate
) {
  const { updateMainGroup, updateChildrenGroup } = useGroupThree({ setChooseGroupeId });
  const childrenGroup = useAppSelector((state) => state.user.group.children);
  const mainGroup = useAppSelector((state) => state.user.group.main);

  useEffect(() => {
    if (isManualUpdate) return;
    if (TEST_MODE) {
      return;
    }

    if (!mainGroup?.groupId) {
      updateMainGroup();
      return;
    }
    if (!chooseGroupId) setChooseGroupeId(mainGroup?.groupId);
  }, [chooseGroupId]);

  useEffect(() => {
    if (isManualUpdate) return;
    if (!chooseGroupId) return;

    const childrenList = Object.values(childrenGroup)?.flat();

    if (childrenGroup[chooseGroupId]) return;
    if (childrenList.find((el) => el.groupId === chooseGroupId)?.game) return;

    updateChildrenGroup(chooseGroupId);
  }, [chooseGroupId]);
}
